import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 17"><path style={{
      stroke: "none",
      fillRule: "evenodd",
      fill: "#9738ff",
      fillOpacity: 1
    }} d="M6.246 4.809v7.543l6.14-3.774zm-.254-1.407l7.711 4.735c.34.207.34.68 0 .886l-7.71 4.735c-.368.226-.848-.024-.848-.442V3.844c0-.418.48-.668.847-.442zm0 0" /></svg>;
}
export default SvgComponent;